<template>
    <section id="contact" class="contact-section">
      <div class="container">
        <h2>Contact Us</h2>
        <p>If you have any questions or need support, feel free to contact us by filling out the form below.</p>
  
        <form @submit.prevent="handleSubmit" class="contact-form">
          <div class="form-group">
            <label for="name">Your Name</label>
            <input
              type="text"
              id="name"
              v-model="form.name"
              placeholder="Enter your name"
              required
            />
          </div>
  
          <div class="form-group">
            <label for="email">Your Email</label>
            <input
              type="email"
              id="email"
              v-model="form.email"
              placeholder="Enter your email"
              required
            />
          </div>
  
          <div class="form-group">
            <label for="message">Your Message</label>
            <textarea
              id="message"
              v-model="form.message"
              placeholder="Enter your message"
              required
            ></textarea>
          </div>
  
          <button type="submit" class="submit-button">Send Message</button>
        </form>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'ContactPage',
    data() {
      return {
        form: {
          name: '',
          email: '',
          message: '',
        },
      };
    },
    methods: {
      handleSubmit() {
        // For now, we'll just log the form data to the console
        console.log('Form Submitted:', this.form);
  
        // You could also use an API call here to submit the form data
        alert('Thank you for reaching out! We will get back to you soon.');
        
        // Reset form after submission
        this.form.name = '';
        this.form.email = '';
        this.form.message = '';
      },
    },
  };
  </script>
  
  <style scoped>
  .contact-section {

    padding: 3rem 0;
    background-color: #f9f9f9;
  }
  
  .container {
    width: 80%;
    margin: 0 auto;
    max-width: 800px;
  }
  
  h2 {
    font-size: 2rem;
    text-align: center;
    margin-bottom: 1.5rem;
  }
  
  .contact-form {
    display: flex;
    flex-direction: column;
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  label {
    font-weight: bold;
    margin-bottom: 0.5rem;
    display: block;
  }
  
  input,
  textarea {
    width: 100%;
    padding: 0.8rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
  
  textarea {
    resize: vertical;
    height: 150px;
  }
  
  .submit-button {
    padding: 1rem;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .submit-button:hover {
    background-color: #0056b3;
  }
  </style>
  